import React, { useState, useEffect, useRef } from 'react';
import { SiGoogle, SiAirbnb } from 'react-icons/si';
import { useLanguage } from '../context/LanguageContext';

const defaultReviews = [
  {
    author: 'Gerasimos',
    date: 'πριν από 5 μήνες',
    rating: 5,
    text: 'Είχαμε μια εξαιρετική εμπειρία κατά τη διαμονή μας στο ενοικιαζόμενο σπίτι! Το κατάλυμα ήταν πεντακάθαρο, πλήρως εξοπλισμένο και πολύ άνετο. Η τοποθεσία του ήταν ιδανική, κοντά σε όλα όσα χρειαζόμασταν, αλλά ταυτόχρονα αρκετά ήσυχη για να απολαύσουμε την ηρεμία μας. Ο ιδιοκτήτης ήταν εξαιρετικά φιλικός και εξυπηρετικός, πάντα διαθέσιμος να μας βοηθήσει με οποιαδήποτε απορία ή ανάγκη προέκυπτε. Μας έδωσε και χρήσιμες συμβουλές για την περιοχή, όπως μέρη για φαγητό και δραστηριότητες. Το σπίτι είχε μοντέρνα διακόσμηση, άνετα κρεβάτια και ό,τι χρειαζόμασταν για να νιώσουμε σαν στο σπίτι μας. Το Wi-Fi ήταν γρήγορο και αξιόπιστο, κάτι που εκτιμήσαμε ιδιαίτερα. Συνολικά, μια φανταστική εμπειρία που θα συνιστούσα ανεπιφύλακτα σε οποιονδήποτε ψάχνει για ποιοτική διαμονή. Ανυπομονούμε να επιστρέψουμε!'
  },
  {
    author: 'Παπαδάκης Ιωάννης',
    date: 'πριν από 5 μήνες',
    rating: 5,
    text: 'Πραγματικά ένα πανέμορφο ζεστό σπίτι, με εκπληκτική θέα. Μείναμε στο Ηράκλειο για ένα μικρό διάστημα καθώς ο προορισμός μας ήταν νότια του Ρεθύμνου. Το πρώτο πράγμα που μας τράβηξε την προσοχή ήταν η θέα όταν κάναμε την κράτηση και όντως είναι απίστευτη. Επίσης το σπίτι είναι πάρα πολύ καθαρό και μύριζε όμορφα κάτι που είναι πολύ ευχάριστο όταν μπαίνεις στην βίλα για πρώτη φορά.'
  },
  {
    author: 'Panagiotis Chandroulidis',
    date: 'πριν από 1 μήνα',
    rating: 5,
    text: 'Ειναι υπέροχο με πανέμορφη θεα. Η ιδιοκτήτρια είναι φιλόξενη και πολύ ευγενική. Σας προτείνω να το επιλέξετε, είμαι σίγουρος θα απολαύσετε την διαμονή σας.'
  },
  {
    author: 'Βασιλης',
    date: '2 Μαρτίου 2025',
    rating: 5,
    text: 'Το σπίτι ήταν πολύ όμορφο και ιδανικό για ρομαντικές αποδράσεις. Ηλεκτρικά εξοπλισμένο και μπορούσαμε να μαγειρέψουμε😊 Η θέα το βράδυ φανταστική από το σπίτι μαζί με ένα κρασάκι το κάτι άλλο. Η οικοδέσποινα μας έστειλε αναλυτικές οδηγίες για το σπίτι. Αρκετά φιλική. Πολύ καλή εντύπωση γενικά.',
    source: 'booking'
  },
  {
    author: 'Σέβη Καλλέργη',
    date: '23 εβδομάδες πριν',
    rating: 5,
    text: 'Μαγευτική θέα και άνετος χώρος. Ήταν καθαρό και όλα στην εν τέλεια! Ήσυχα και ξεκούραστα. Θα ξαναπάω σίγουρα!'
  },
  {
    author: 'alex tevre',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Visiting Crete frequently, I can honestly say that this was one of the best apartments I\'ve ever stayed in! The amazing...'
  },
  {
    author: 'Ειρηνη Βρεντζου',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Πραγματικά υπέροχα.... Δεν έχω λόγια να περιγράψω την ομορφιά..όλα άψογα και προσεγμένα...το συστήνω ανεπιφύλακτα...'
  },
  {
    author: 'Αντωνης Αερακης',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Ήταν όλα τέλεια ! Υπεροχος και καθαρός χώρος με απίστευτη θέα !'
  },
  {
    author: 'Konstantina Orfanou',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Πολύ όμορφος χώρος και οι οικοδεσποτες φιλικοι, εξυπηρετικοί και πρόθυμοι να βοηθήσουν....'
  },
  {
    author: 'Πένυ Σταθογιαννοπούλου',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Υπέροχος χώρος με πολύ όμορφη αισθητική. Πεντακάθαρο και προσεγμένο μεχρι την τελευταία πινελιά! Το αγαπημένο μου μέρος...'
  },
  {
    author: 'MARIA IOANNA RESTIVAKI',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'If you\'re looking for a peaceful and scenic getaway, this holiday house in Rodia is an excellent choice!...'
  },
  {
    author: 'Μαρία Σταυρουλάκη',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Πολύ όμορφος ο χώρος και σε συνδυασμό με την απίστευτη θέα του Ηρακλείου έκανε την διαμονή μας αξέχαστη!!'
  },
  {
    author: 'βασιλης μαρης',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Σας δίνω τα συγχαρητήρια μου για το πόσο όμορφο και ανακαινισμένο είναι το σπίτι σας.Η διαμονή μας ήταν υπέροχη και το...'
  },
  {
    author: 'Μάνος Παπαδάκης',
    date: '24 εβδομάδες πριν',
    rating: 5,
    text: 'Πολύ ωραία θέα, ο ενοικιαστής πολύ εξυπηρετικός και ότι πρόβλημα είχα λυνόταν απευθείας το συνιστώ ανεπιφύλακτα για τις διακοπές σας είτε καλοκαιρινές είτε χειμερινές 😁'
  },
  {
    author: 'Panagiotis',
    date: '25 Ιουνίου 2025',
    rating: 5,
    text: 'Οι ιδιοκτήτρια και η διαχειρίστρια είναι υπέροχοι άνθρωποι, φιλόξενοι και ευγενικοί. Είχαμε μια τέλεια διαμονή και μια υπέροχη συνεργασία. Το σπίτι ηταν καθαρό και κατά την άφιξη μας μας περίμενε ενα ωραίο κέρασμα. Μα το Highlight ειναι το μπαλκόνι, η θέα είναι πανέμορφη, βλέπεις όλο το Ηράκλειο και το απέραντο γαλάζιο της θάλασσας.',
    source: 'booking'
  },
  {
    author: 'Lise',
    date: 'Μάιος 2025',
    rating: 3,
    text: 'Καλή τοποθεσία για να επισκεφτείτε την περιοχή του Ηρακλείου και κοντά στο αεροδρόμιο. Μικρό κατάλυμα για 4 άτομα (συμπεριλαμβανομένων των παιδιών, σπειροειδής σκάλα). Απαιτούνται ορισμένες βελτιώσεις...',
    source: 'airbnb'
  },
  {
    author: 'Εμμανουήλ',
    date: 'Απρίλιος 2025',
    rating: 5,
    text: 'Ήρεμο μέρος με ωραία θέα. Η επικοινωνία ήταν εξαιρετική.',
    source: 'airbnb'
  },
  {
    author: 'Εμμανουήλ',
    date: 'Μάρτιος 2025',
    rating: 5,
    text: 'Το σπίτι ήταν πολύ καθαρό και η θέα από το μπαλκόνι ήταν το κάτι άλλο και είχες όλες τις παροχές και η οικοδεσπότης πολύ φιλική και με βοήθησε σε ότι πρόβλημα και αν ειχα',
    source: 'airbnb'
  },
];

const GOOGLE_LOGO = (
  <svg width="40" height="40" viewBox="0 0 48 48"><g><path d="M43.611,20.083h-1.857V20H24v8h11.284c-1.649,4.657-6.076,8-11.284,8c-6.627,0-12-5.373-12-12s5.373-12,12-12 c2.73,0,5.232,0.936,7.217,2.482l6.071-6.071C33.527,6.053,28.979,4,24,4C12.954,4,4,12.954,4,24s8.954,20,20,20 c11.046,0,20-8.954,20-20C44,22.659,43.862,21.35,43.611,20.083z" fill="#FFC107"/><path d="M6.306,14.691l6.571,4.819C15.655,15.671,19.522,13,24,13c2.73,0,5.232,0.936,7.217,2.482l6.071-6.071 C33.527,6.053,28.979,4,24,4C16.318,4,9.656,8.797,6.306,14.691z" fill="#FF3D00"/><path d="M24,44c4.783,0,9.29-1.688,12.764-4.555l-5.897-4.995C28.232,36.064,26.211,37,24,37 c-5.186,0-9.601-3.326-11.259-7.963l-6.535,5.045C9.627,39.125,16.319,44,24,44z" fill="#4CAF50"/><path d="M43.611,20.083h-1.857V20H24v8h11.284c-0.793,2.238-2.23,4.166-4.117,5.452 c0.001-0.001,0.002-0.001,0.003-0.002l5.897,4.995C39.684,39.019,44,32.5,44,24C44,22.659,43.862,21.35,43.611,20.083z" fill="#1976D2"/></g></svg>
);

const ICONS = {
  google: GOOGLE_LOGO,
  booking: (
    <svg width="40" height="40" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#003580"/><text x="50%" y="60%" textAnchor="middle" fontSize="28" fill="#fff" fontFamily="Arial,Helvetica,sans-serif" fontWeight="bold">B</text></svg>
  ),
  airbnb: <SiAirbnb size={40} color="#FF5A5F" />
};

function ReviewCard({ review }) {
  const source = review.source || 'google';
  const [expanded, setExpanded] = useState(false);
  const { t } = useLanguage();
  const maxLength = 250;
  const isLong = review.text.length > maxLength;
  const displayText = expanded || !isLong ? review.text : review.text.slice(0, maxLength) + '...';
  return (
    <div className="bg-white rounded-2xl shadow-md p-5 md:p-10 flex-1 mx-1 md:mx-2 flex flex-col justify-between min-h-[220px] md:min-h-[500px] h-full border border-gray-100 relative text-lg md:text-3xl">
      <div className="flex items-center mb-2 md:mb-4">
        {/* Stars */}
        {Array.from({ length: 5 }).map((_, i) =>
          i < review.rating ? (
            <svg key={i} width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" className="mr-1 md:mr-2"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
          ) : (
            <svg key={i} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" className="mr-1 md:mr-2"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
          )
        )}
      </div>
      <blockquote className="italic text-gray-700 text-lg md:text-3xl mb-3 md:mb-6 flex-grow">
        "{displayText}"
        {isLong && (
          <button
            className="ml-2 text-blue-600 underline text-base md:text-xl font-medium focus:outline-none"
            onClick={() => setExpanded((v) => !v)}
          >
            {expanded ? t('readLess') : t('readMore')}
          </button>
        )}
      </blockquote>
      <div className="flex items-center justify-between mt-auto">
        <div>
          <div className="font-semibold text-gray-800 text-base md:text-2xl">{review.author}</div>
          <div className="text-gray-400 text-xs md:text-lg">{review.date}</div>
        </div>
        <div className="absolute bottom-3 md:bottom-6 right-3 md:right-6">{ICONS[source]}</div>
      </div>
    </div>
  );
}

export default function GoogleReviewsCarousel() {
  // Ξεχωριστό index για κάθε carousel ώστε να μην πέφτει error μετά τη 5η-6η slide
  const [reasonsIndex, setReasonsIndex] = useState(0);
  const [reviewsIndex, setReviewsIndex] = useState(0);
  const { t } = useLanguage();
  
  // Touch state for swipe
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  // Use translated reviews if available, else fallback
  let reviews = t('reviews');
  if (!Array.isArray(reviews)) {
    reviews = defaultReviews;
  }

  // Show 2 reviews per slide on desktop, 1 per slide on mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const slides = [];
  if (isMobile) {
    for (let i = 0; i < reviews.length; i++) {
      slides.push([reviews[i]]);
    }
  } else {
    for (let i = 0; i < reviews.length; i += 2) {
      slides.push([reviews[i], reviews[i + 1] ?? null].filter(Boolean));
    }
  }
  const slidesCount = slides.length;
  const prev = () => setReviewsIndex((i) => (i === 0 ? slidesCount - 1 : i - 1));
  const next = () => setReviewsIndex((i) => (i === slidesCount - 1 ? 0 : i + 1));

  // Swipe handlers for reviews
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const diff = touchStartX.current - touchEndX.current;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          next(); // swipe left
        } else {
          prev(); // swipe right
        }
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  // Replace Top 5 Reasons section with a Greek carousel version
  const reasons = [
    {
      title: t('reasons.reason1.title'),
      description: t('reasons.reason1.description'),
      image: '/0EEEAAA0-5C26-4738-B982-12C42C6A77ED.jpeg',
    },
    {
      title: t('reasons.reason2.title'),
      description: t('reasons.reason2.description'),
      image: '/koyle.jpg',
    },
    {
      title: t('reasons.reason3.title'),
      description: t('reasons.reason3.description'),
      image: '/ayth.jpg',
    },
    {
      title: t('reasons.reason4.title'),
      description: t('reasons.reason4.description'),
      image: '/ligaria.webp',
    },
    {
      title: t('reasons.reason5.title'),
      description: t('reasons.reason5.description'),
      image: '/relax.jpg',
    },
  ];

  // Top 5 Reasons carousel auto-advance logic (μόνο για reasons, όχι για reviews)
  const autoAdvanceTimeout = useRef();
  useEffect(() => {
    function startAutoAdvance() {
      autoAdvanceTimeout.current = setTimeout(() => {
        setReasonsIndex((prev) => (prev + 1) % reasons.length);
      }, 15000); // 15 δευτ. για πιο αργή αλλαγή
    }
    startAutoAdvance();
    return () => clearTimeout(autoAdvanceTimeout.current);
  }, [reasonsIndex, reasons.length]);

  // Swipe handlers for reasons
  const reasonsTouchStartX = useRef(null);
  const reasonsTouchEndX = useRef(null);
  const handleReasonsTouchStart = (e) => {
    reasonsTouchStartX.current = e.touches[0].clientX;
  };
  const handleReasonsTouchMove = (e) => {
    reasonsTouchEndX.current = e.touches[0].clientX;
  };
  const handleReasonsTouchEnd = () => {
    if (reasonsTouchStartX.current !== null && reasonsTouchEndX.current !== null) {
      const diff = reasonsTouchStartX.current - reasonsTouchEndX.current;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          handleUserNav((reasonsIndex + 1) % reasons.length); // swipe left
        } else {
          handleUserNav((reasonsIndex - 1 + reasons.length) % reasons.length); // swipe right
        }
      }
    }
    reasonsTouchStartX.current = null;
    reasonsTouchEndX.current = null;
  };

  // Pause auto-advance on user interaction (μόνο για Reasons)
  const handleUserNav = (newIndex) => {
    clearTimeout(autoAdvanceTimeout.current);
    setReasonsIndex(newIndex);
    autoAdvanceTimeout.current = setTimeout(() => {
      setReasonsIndex((prev) => (prev + 1) % reasons.length);
    }, 20000); // 20 δευτ. μετά από κλικ
  };

  return (
    <>
      {/* Top 5 Reasons Section */}
      <section
        className="w-full min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
        style={{ backgroundImage: "url('/back2.png')", backgroundSize: 'cover', backgroundPosition: 'center' }}
        onTouchStart={handleReasonsTouchStart}
        onTouchMove={handleReasonsTouchMove}
        onTouchEnd={handleReasonsTouchEnd}
      >
        {/* Overlay for readability */}
        <div className="absolute inset-0 bg-white/70 pointer-events-none z-0" />
        <div className="relative z-10 w-full flex flex-col items-center justify-center">
          <h2 className="text-xl sm:text-2xl md:text-6xl font-extrabold text-gray-900 text-center mb-4 md:mb-12" style={{ fontWeight: 700, fontFamily: 'Caveat, Poppins, Montserrat, Inter, sans-serif', letterSpacing: '0.04em' }}>
            {t('reasons.title')}
          </h2>
          <div className="relative w-full max-w-7xl flex flex-col items-center justify-center min-h-[320px] md:min-h-[600px]">
            <img src={reasons[reasonsIndex].image} alt={reasons[reasonsIndex].title} className="rounded-2xl md:rounded-3xl shadow-2xl w-full h-[180px] md:h-[520px] object-cover object-center mb-4 md:mb-8" />
            <div className="bg-white/90 rounded-xl md:rounded-2xl p-4 md:p-16 shadow-2xl text-center w-full max-w-5xl mx-auto">
              <div className="text-2xl md:text-5xl font-bold text-blue-900 mb-2 md:mb-6">{reasons[reasonsIndex].title}</div>
              <div className="text-base md:text-3xl text-gray-800 font-medium leading-relaxed">{reasons[reasonsIndex].description}</div>
            </div>
            {/* Βελάκια αφαιρέθηκαν */}
            <div className="flex justify-center mt-4 md:mt-8 gap-2 md:gap-3">
              {reasons.map((_, i) => (
                <button
                  key={i}
                  className={`w-3 md:w-4 h-3 md:h-4 rounded-full ${i === reasonsIndex ? 'bg-blue-500' : 'bg-gray-300'}`}
                  onClick={() => handleUserNav(i)}
                  aria-label={`Go to reason ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section
        className="w-full flex flex-col items-center justify-center min-h-screen relative overflow-hidden"
        style={{ backgroundImage: "url('/Beige-Background.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Overlay for readability */}
        <div className="absolute inset-0 bg-white/70 pointer-events-none z-0" />
        <div className="relative z-10 w-full flex flex-col items-center h-full min-h-screen">
          <div className="w-full pt-4 md:pt-8 pb-1 md:pb-2">
            <div className="text-gray-700 text-base sm:text-xl md:text-4xl mt-2 md:mt-8 mb-1 md:mb-4 tracking-wide text-center font-semibold" style={{ fontWeight: 500, letterSpacing: '0.04em', fontFamily: 'Dancing Script, Poppins, Montserrat, Inter, sans-serif' }}>
              <div><a>{t('reviewsSection.subtitle')}</a></div>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-6xl font-extrabold mb-1 md:mb-6 text-gray-900 text-center" style={{ fontWeight: 700, fontFamily: 'Dancing Script, Poppins, Montserrat, Inter, sans-serif' }}>
              <a> {t('reviewsSection.title')}</a>
            </h2>
          </div>
          <div className="flex-grow flex items-center justify-center w-full">
            <div className="relative w-full max-w-7xl flex items-center justify-center min-h-[220px] md:min-h-[400px] px-0 md:px-2 h-full">
              {/* Ασφαλές index ώστε να μην πετάει error μετά τη 5η-6η slide */}
              {(() => {
                const safeIndex = Math.min(Math.max(0, reviewsIndex), slidesCount - 1);
                const slide = slides[safeIndex];
                if (!slide || !Array.isArray(slide)) return null;
                return (
                  <div className="flex w-full justify-center gap-3 md:gap-12 h-full items-stretch">
                    {slide.map((review, i) => review && <ReviewCard key={`${safeIndex}-${i}`} review={review} />)}
                  </div>
                );
              })()}
            </div>
          </div>
          <div className="flex justify-center mt-4 md:mt-8 gap-1 md:gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`w-2 md:w-3 h-2 md:h-3 rounded-full ${i === reviewsIndex ? 'bg-blue-500' : 'bg-gray-300'}`}
                onClick={() => setReviewsIndex(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
} 